var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgService(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_397_612)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5263 13C20.5263 13.3763 20.2184 13.6842 19.8421 13.6842H13.6842V19.8421C13.6842 20.2184 13.3763 20.5263 13 20.5263C12.6237 20.5263 12.3158 20.2184 12.3158 19.8421V13.6842H6.15789C5.78158 13.6842 5.47368 13.3763 5.47368 13C5.47368 12.6237 5.78158 12.3158 6.15789 12.3158H12.3158V6.15789C12.3158 5.78158 12.6237 5.47368 13 5.47368C13.3763 5.47368 13.6842 5.78158 13.6842 6.15789V12.3158H19.8421C20.2184 12.3158 20.5263 12.6237 20.5263 13ZM26 13C26 20.1842 20.1842 26 13 26C5.81579 26 0 20.1842 0 13C0 5.81579 5.81579 0 13 0C20.1842 0 26 5.81579 26 13ZM24.6316 13C24.6316 6.56842 19.4316 1.36842 13 1.36842C6.56842 1.36842 1.36842 6.56842 1.36842 13C1.36842 19.4316 6.56842 24.6316 13 24.6316C19.4316 24.6316 24.6316 19.4316 24.6316 13Z",
    fill: "#0ABD19"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_397_612"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService);
export default __webpack_public_path__ + "static/media/service.29fc0ce6ce1fd6fdb2a8cdcb56170a6f.svg";
export { ForwardRef as ReactComponent };